import { Injectable } from '@angular/core';
import { of, switchMap } from 'rxjs';
import { CommunicationManagerService } from './communication-manager.service';
import { LocalStorageService } from './storage.service';
import { catchError, tap } from 'rxjs/operators';
import { FiscalYear } from '@ops/shared-types';


@Injectable({ providedIn: 'root' })
export class FiscalYearService {

  constructor(
    private cm: CommunicationManagerService,
    private localStorageService: LocalStorageService
  ) {}

  getFiscalYearsForCompany(companyId: string) {
    const fiscalYears = this.localStorageService.getFiscalYearsForCompany();
    if (fiscalYears?.length) {
      return of(fiscalYears);
    } else {
      return this.cm
        .get('fiscalYear/company', [
          { headerName: 'companyId', headerValue: companyId },
        ])
        .pipe(
          tap((fiscalYears: FiscalYear[]) => {
            this.localStorageService.setFiscalYearsForCompany(fiscalYears);
            // this.loadingService.setLoading(false);
          }),
          catchError((error) => {
            // console.log('error', error);
            this.localStorageService.setFiscalYearsForCompany([]);
            return of([]); // Return empty array as observable
          }),
          switchMap((fiscalYears) => {
            // console.log('SHOULD TRACK 4');

            return of(fiscalYears);
          })
        );
    }
  }
}
